<template>
    <div class="issueBullet"
         :class="{active : this.$store.state.issueSliderBulletStore.currentPage === id}"
         @click="_handleSliderChangeByBullet(id)"
    />

</template>

<script>
    export default {
        name: "issue-slider-bullet",
        props: ['id'],
        data () {
          return {
            currentPage : this.$store.state.issueSliderBulletStore.currentPage,
          }
        },
        methods : {
          _handleSliderChangeByBullet (id = 1) {
            //this.$parent.$refs.slider.$emit('slideTo', id);
            //this.$parent.slideTo(id);
            this.$emit('handleSliderBullet' , id);
          },
        }

    }
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/menu/Sunnyfactory/IssueSliderBullet.vue